import Styled from "styled-components";

export interface ContainerProps {
  $size?: string;
}

export const Container = Styled.img<ContainerProps>`
  display: block;
  width: ${(props) => props.$size || "1rem"};
  height: ${(props) => props.$size || "1rem"};

  ${(props) =>
    props.theme.mode === "light" &&
    `
    box-shadow: 0px 0.326px 0.13px 0px #4F5053 inset, 0px -0.204px 0.272px 0px rgba(0, 0, 0, 0.25) inset, 0px 4px 6px -2px rgba(17, 17, 17, 0.40);
    border-radius: 1rem;
  `}
`;
